import 'moment';
import * as React      from 'react';
import * as PropTypes  from 'prop-types';
import moment          from 'moment-timezone';
import { getTimeZone } from '../helpers/timeUtils';
import {
    UserSession,
    UserLanguages
}                      from '../types';

interface AgoProps {
    time: string;
    interval?: number;
}

interface AgoState {
    currentTime: string;
    language?: string;
}

interface AgoContext {
    session: UserSession;
}

export default class Ago extends React.PureComponent<AgoProps, AgoState> {

    protected static timerList: Ago[] = [];

    protected static interval?: number = null;

    protected bulkUpdateTimers() {
        for (const timer of Ago.timerList) {
            timer.setState({
                currentTime: this.getFullTime(timer.props.time)
            });
        }
    }

    protected checkTimer() {
        if (!Ago.interval && Ago.timerList.length) {
            Ago.interval = window.setInterval(this.bulkUpdateTimers.bind(this), Ago.scheduleTime);
        }
    }

    protected addTimer(element: Ago) {
        if (Ago.timerList.indexOf(element) === -1) {
            Ago.timerList.push(element);
        }
    }

    protected removeTimer(element: Ago) {
        const index = Ago.timerList.indexOf(element);

        if (index !== -1) {
            Ago.timerList.splice(index, 1);
        }
    }

    public static scheduleTime: number = 60000;

    static contextTypes = {
        session: PropTypes.object
    };

    context: AgoContext;

    constructor(props, context) {
        super(props);

        moment.locale(context.session && context.session.user_language || UserLanguages.ENGLISH);

        this.state = {
            currentTime: this.getFullTime(props.time)
        };
    }

    componentDidMount() {
        this.addTimer(this);
        this.checkTimer();
    }

    componentWillReceiveProps(nextProps: AgoProps) {
        if (nextProps.time !== this.props.time) {
            this.setState({
                currentTime: this.getFullTime(nextProps.time)
            });
        }
    }

    componentWillUnmount() {
        this.removeTimer(this);

        if (Ago.interval && Ago.timerList.length === 0) {
            window.clearInterval(Ago.interval);
            Ago.interval = null;
        }
    }

    getFullTime(time: string) {
        return moment(moment(time + '+00:00').tz(getTimeZone())).fromNow();
    }

    render() {
        return (
            <span>{this.state.currentTime}</span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Ago.tsx